import React from 'react';
import { Box, Typography, Button, styled } from '@mui/material';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  maxWidth: 400, 
  bgcolor: 'background.paper',
  border: '1px solid #ccc', 
  boxShadow: '0px 3px 5px rgba(0,0,0,0.2)', 
  p: 4,
  borderRadius: 4,
  textAlign: 'center',
};

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
  borderRadius: 6,
  padding: theme.spacing(1.5, 3), 
  fontWeight: 'bold',
}));

const TokenExpirePopup = ({ onClose }) => {
  const handleLoginClick = () => {
    
    if (onClose) {
      onClose();
    }
   
    window.location.reload();
  };

  return (
    <Box sx={modalStyle}>
      <Typography id="token-expire-modal-title" variant="h6" component="h2" sx={{ mb: 2, fontWeight: 'bold' }}>
        Session Expired
      </Typography>
      <Typography id="token-expire-modal-description" sx={{ mb: 3, color: 'text.secondary' }}>
        Your login session has expired. Please log in again.
      </Typography>
      <StyledButton 
        onClick={handleLoginClick} 
        variant="contained" 
        color="primary"
      >
        Log In
      </StyledButton>
    </Box>
  );
};

export default TokenExpirePopup;